import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../core'

export const RESOURCE = {
  payload: {
    description: 'The intensity of engagement planned for a stakeholder',
    name: 'Stakeholder Engagement Needed',
    partialId: PartialId.Standard.create('stakeholder_engagement_needed'),
  },
  type: core.quiver.Resource.Type.DmsEnum,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEnum>
